module.exports = __webpack_public_path__ + "static/UNL-767d52a30154955ccfac62aabcf835f2.eot";